/**
 * The productive business units (D4). The page is scoped to these three in the DATA as well as
 * the picker — the API applies the same list as its first row condition, and migration 132
 * built the check table's group set from it.
 *
 * The picker is cut against this constant rather than trusting whatever the filter endpoint
 * returns: if a GEN row ever leaks back into the warehouse, the dropdown must not quietly start
 * offering a fourth unit the list cannot show rows for.
 */
export const CB_BUSINESS_UNITS = ['PLA', 'SPC', 'F&P'] as const;

export type CbBusinessUnit = typeof CB_BUSINESS_UNITS[number];

export function isProductiveBusinessUnit(code: string): boolean {
    return (CB_BUSINESS_UNITS as readonly string[]).includes(code);
}

/** PROD portal, intentionally hard-coded: deal ids come from the PROD replica and resolve only
 *  there (ID-provenance rule, context/docs/hubspot-integration.md). */
export const HUBSPOT_DEAL_BASE = 'https://app.hubspot.com/contacts/5732437/record/0-3/';
